export default {
  cemeteryState(state) {
    return state.details;
  },
  cemeteryLoadingState(state) {
    return state.detailsLoading;
  },
};
